import awsRumActionNames from '../../../consts/aws/awsRumActionNames';
import rumCustomEvents from '../../../services/events/rumCustomEvents';
import {twx} from '../../../utils/tailwindUtils';

const ToggleSwitch = ({onClick, isDisabled, isActive, isLarge, className, rumActionName: customRumActionName}) => {
    const onClickHandler = () => {
        // isActive is the state before the click, so the recorded name is the state the click produces
        const rumActionName = customRumActionName || (isActive ? awsRumActionNames.OFF : awsRumActionNames.ON);

        rumCustomEvents.recordActionClick({rumActionName});

        onClick(!isActive);
    };

    return (
        <div
            onClick={onClickHandler}
            className={twx(
                'relative flex w-16 shrink-0 cursor-pointer rounded-full p-[3px] transition-all duration-300',
                isActive ? 'bg-color-tertiary' : 'bg-[#9C9FA1] dark:bg-[#9C9FA1]',
                isLarge && 'w-[84px] p-1',
                isDisabled && 'opacity-40',
                className
            )}
        >
            <div
                className={twx(
                    'relative h-6 w-6 rounded-full transition-all duration-300 ',
                    isActive
                        ? 'left-full -translate-x-full bg-color-slate-gray'
                        : 'left-0 bg-color-light-silver dark:bg-color-slate-gray',
                    isLarge && 'h-8 w-8'
                )}
            />
        </div>
    );
};

export default ToggleSwitch;
